import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader, StyledGridCol, StyledGridRow } from "@/common/styles";
import { useMemo, useState } from "react";
import styled from "styled-components";

const SettingsWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;

  & > label {
    flex-basis: calc(50% - 15px);
  }
`;

const GroupSecurityRules = (props) => {
  const [ruleType, setRuleType] = useState("-");

  const ruleTypeFields = useMemo(() => {
    switch (ruleType) {
      case "arbitrary":
        return (
          <section>
            <IntakeSectionHeader style={{ marginTop: 15 }}>
              <span>Arbitrary Rule</span>
            </IntakeSectionHeader>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={24}>
                <FormItem label="Arbitrary Name">
                  <TextField name="arbitraryName" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </section>
        );
      case "field":
        return (
          <section>
            <IntakeSectionHeader style={{ marginTop: 15 }}>
              <span>Field Rule</span>
            </IntakeSectionHeader>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={8}>
                <FormItem label="Table Name">
                  <Select name="tableName" options={[{ value: "-", label: "", disabled: true }]} />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={8}>
                <FormItem label="Starting Point">
                  <TextField name="startingPoint" />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={8}>
                <FormItem label="Field Name">
                  <TextField name="fieldName" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </section>
        );
      case "report":
        return (
          <section>
            <IntakeSectionHeader style={{ marginTop: 15 }}>
              <span>Report Rule</span>
            </IntakeSectionHeader>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={24}>
                <FormItem label="Report">
                  <Select name="report" options={[{ value: "-", label: "Select", disabled: true }]} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </section>
        );
      case "submodule":
        return (
          <section>
            <IntakeSectionHeader style={{ marginTop: 15 }}>
              <span>Submodule Rule</span>
            </IntakeSectionHeader>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <FormItem label="Module">
                  <Select name="module" options={[{ value: "-", label: "Select", disabled: true }]} />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={12}>
                <FormItem label="Submodule">
                  <Select name="submodule" options={[{ value: "-", label: "Select", disabled: true }]} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </section>
        );
      case "record":
        return (
          <section>
            <IntakeSectionHeader style={{ marginTop: 15 }}>
              <span>Record Rule</span>
            </IntakeSectionHeader>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={24}>
                <FormItem label="Starting Point">
                  <TextField name="startingPoint" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={8}>
                <FormItem label="Table Name">
                  <Select name="tableName" options={[{ value: "-", label: "Select", disabled: true }]} />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={8}>
                <FormItem label="Record ID">
                  <TextField name="recordId" />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={8}>
                <FormItem label="Password">
                  <TextField name="password" type="password" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </section>
        );
      case "criteria":
        return (
          <section>
            <IntakeSectionHeader style={{ marginTop: 15 }}>
              <span>Criteria Rule</span>
            </IntakeSectionHeader>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={12}>
                <FormItem label="Global Criteria">
                  <Select name="globalCriteria" options={[{ value: "-", label: "Select", disabled: true }]} />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={12}>
                <FormItem label="Starting Point">
                  <TextField name="startingPoint" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={[16]}>
              <StyledGridCol span={24}>
                <FormItem label="Comments">
                  <TextField name="comments" inputType="textarea" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </section>
        );
      default:
        return null;
    }
  }, [ruleType]);

  return (
    <>
      <section>
        <IntakeSectionHeader style={{ marginTop: 0 }}>
          <span>Staff Groups</span>
        </IntakeSectionHeader>
        <StyledGridRow gutter={[16]}>
          <StyledGridCol span={24}>
            <FormItem label="Add Member to">
              <Select id="staffGroup" name="staffGroup" options={[{ value: "-", label: "Select", disabled: true }]} />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={[16]}>
          <StyledGridCol span={4}>
            <FormItem label="ID">
              <TextField name="id" />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={8}>
            <FormItem label="Date & Time Entered">
              <CommonDatePicker name="name" showTime />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={12}>
            <FormItem label="User">
              <TextField name="user" />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </section>
      <section>
        <IntakeSectionHeader>
          <span>Rule Type & Status</span>
        </IntakeSectionHeader>
        <StyledGridRow gutter={[16]} alignItems={"center"}>
          <StyledGridCol span={18}>
            <FormItem label="Rule Type">
              <Select
                id="ruleType"
                name="ruleType"
                value={ruleType}
                onChange={(ruleType) => setRuleType(ruleType)}
                options={[
                  { value: "-", label: "Select", disabled: true },
                  { value: "arbitrary", label: "Arbitrary" },
                  { value: "field", label: "Field" },
                  { value: "report", label: "Report" },
                  { value: "submodule", label: "Submodule" },
                  { value: "record", label: "Record" },
                  { value: "criteria", label: "Criteria" },
                ]}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol span={6}>
            <Checkbox>Is Rule Active?</Checkbox>
          </StyledGridCol>
        </StyledGridRow>
        <div style={{ marginLeft: 10 }}>
          {ruleTypeFields}
          <StyledGridRow gutter={[24]}>
            <StyledGridCol span={12}>
              <section>
                <IntakeSectionHeader style={{ marginTop: 15 }}>
                  <span>Allowed Settings</span>
                </IntakeSectionHeader>
                <SettingsWrapper>
                  <Checkbox name="add">Add</Checkbox>
                  <Checkbox name="allRights">All Rights</Checkbox>
                  <Checkbox name="delete">Delete</Checkbox>
                  <Checkbox name="find">Find</Checkbox>
                  <Checkbox name="lock">Lock</Checkbox>
                  <Checkbox name="modify">Modify</Checkbox>
                  <Checkbox name="noRights">No Rights</Checkbox>
                  <Checkbox name="print">Print</Checkbox>
                  <Checkbox name="reports">Reports</Checkbox>
                  <Checkbox name="tableView">Table View</Checkbox>
                  <Checkbox name="unlock">Unlock</Checkbox>
                  <Checkbox name="view">View</Checkbox>
                </SettingsWrapper>
              </section>
            </StyledGridCol>
            <StyledGridCol span={12}>
              <section>
                <IntakeSectionHeader style={{ marginTop: 15 }}>
                  <span>Denied Settings</span>
                </IntakeSectionHeader>
                <SettingsWrapper>
                  <Checkbox name="add">Add</Checkbox>
                  <Checkbox name="allRights">All Rights</Checkbox>
                  <Checkbox name="delete">Delete</Checkbox>
                  <Checkbox name="find">Find</Checkbox>
                  <Checkbox name="lock">Lock</Checkbox>
                  <Checkbox name="modify">Modify</Checkbox>
                  <Checkbox name="noRights">No Rights</Checkbox>
                  <Checkbox name="print">Print</Checkbox>
                  <Checkbox name="reports">Reports</Checkbox>
                  <Checkbox name="tableView">Table View</Checkbox>
                  <Checkbox name="unlock">Unlock</Checkbox>
                  <Checkbox name="view">View</Checkbox>
                </SettingsWrapper>
              </section>
            </StyledGridCol>
          </StyledGridRow>
          <StyledGridRow gutter={[16]} marginTop="25px">
            <StyledGridCol span={4}>
              <FormItem label="ID">
                <TextField name="id" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={8}>
              <FormItem label="Date & Time Entered">
                <CommonDatePicker name="name" showTime />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol span={12}>
              <FormItem label="User">
                <TextField name="user" />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </div>
      </section>
    </>
  );
};

export default GroupSecurityRules;
